module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAAAqCAYAAAA3f5z+AAAAAXNSR0IArs4c6QAAALlJREFUaEPt27ENg0AUBcGPW6A+9+JeHFMaLYAlAncwJOwVsCfNvfSW2c7PdJjAEjCzvcJ/4Nd7tTc9rH5894DlmwcsdWcm4ICxAM634ICxAM634ICxAM634ICxAM634ICxAM634ICxAM634ICxAM634ICxAM634ICxAM634ICxAM634ICxAM634ICxAM634ICxAM634ICxAM634ICxAM634ICxAM634ICxAM634LuB8X2PzfdPDj/9D49KzWNK6ClpAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2dmap/pop_btn_normal.png
// module id = JUpe
// module chunks = 2